module.exports = __webpack_public_path__ + "static/desktop/img/diarybook-1-thumb.d79b453f.png";